import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useCreateChat } from '@packages/shared/core/chat/hooks';
import { useLogger, useRedirectToMainApp } from '@packages/shared/core/common/hooks';
import { getSelectedExpert } from '@packages/shared/core/experts/store';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { OfferStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type OfferQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const OfferQuizStep = ({ id, renderQuizScreen }: OfferQuizStepProps) => {
  const logger = useLogger();

  const { redirectToSignupFreeTrialPage } = useRedirectToMainApp();
  const { back, stepData, userPreferences } = useQuizStep(id);

  const { createChat } = useCreateChat();
  const expert = useSelector(getSelectedExpert);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { getGoal } = stepData as OfferStepData;

  const goBack = async () => back();

  const goNext = async () => {
    await redirectToSignupFreeTrialPage();
  };

  const redirectToChat = async () => {
    if (!expert) {
      await goNext();
      return;
    }

    await createChat(expert.id);
  };

  return (
    <>
      {renderQuizScreen({
        goBack,
        goNext,
        goal: getGoal(userPreferences.goal),
        redirectToChat,
        ...(stepData as OfferStepData),
      })}
    </>
  );
};

export default OfferQuizStep;
